import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaneService } from 'src/app/services/pane.service';
import { LightDarkThemes } from 'src/models/AppTheme';
import {ThemeColorService} from '../../services/ui/theme-color.service';
import {isK3000domain} from '../../core/common';
import { MainClickDirectiveDirective } from '../../utils/directives/main-click-directive.directive';
import { TooltipDirective } from '../../utils/directives/tooltip.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'asg-no-tab-bottom-toolbar',
    templateUrl: './no-tab-bottom-toolbar.component.html',
    styleUrls: ['./no-tab-bottom-toolbar.component.scss'],
    standalone: true,
    imports: [NgClass, TooltipDirective, MainClickDirectiveDirective]
})
export class NoTabBottomToolbarComponent implements OnInit, OnDestroy {
  currentTheme: LightDarkThemes;
  lightDarkThemes = LightDarkThemes;
  panesLimit = false;
  isK3000 = isK3000domain();
  hideTogglePanes = false;
  private readonly subscriptions: Subscription = new Subscription();
  // conditionsUrl: string;
  // releaseNotesUrl: string;
  constructor(
    private paneService: PaneService,
    private ngZone: NgZone,
    private themeService: ThemeColorService
  ) { }

  ngOnInit(): void {
    this.subToThemeChange();
    this.subToHideTogglePanes();
    this.subscriptions.add(
      this.paneService.getPanesLimit().subscribe(e => {
      this.ngZone.run(() => {
        this.panesLimit = e;
      });
    }));
    this.currentTheme = this.themeService.getCurrentLightDarkTheme();
    // this.conditionsUrl = isK3000domain() ? 'BOTTOMBAR.K3000_CONDITIONSURL' : 'BOTTOMBAR.ALINEA_CONDITIONSURL';
    // this.releaseNotesUrl = `SETTINGS.ABOUT.${isK3000domain() ? 'RELEASE_NOTES_K3000_URL' : 'RELEASE_NOTES_URL'}`;
  }

  ngOnDestroy(): void{
    this.subscriptions.unsubscribe();
  }

  togglePanes = () => {
    this.paneService.togglePanes();
  }

  private subToThemeChange(): void {
    this.subscriptions.add(
      this.themeService.ThemeChanged.subscribe((e: LightDarkThemes) => {
        this.currentTheme = e;
      })
    );
  }

  private subToHideTogglePanes(): void {
    this.subscriptions.add(
      this.paneService.HideTogglePanes.subscribe(isHidden => this.hideTogglePanes = isHidden)
    );
  }
}
